import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { BehaviorSubject, Subscription, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { MemberDirectory, memberDirectoryDefault } from 'app/shared/models/directory.model';
import {ErrorHandlingUtilsService} from '../../shared/services/error-handling-utils.service';
import {catchError} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class DirectoryService {
  public openLDAPTypeName = 'openLDAP';
  public ADTypeName = 'Active Directory';
  public gSuiteTypeName = 'G Suite';
  public azureADTypeName = 'Azure AD';
  public scimTypeName = 'SCIM';
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  sub: Subscription;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingUtilsService) {
  }

  getDirectoryList() {
    return this.http.get<MemberDirectory[]>('/api/member_directory').pipe(
      catchError(err => this.handleHttpError(err, []))
    );
  }

  getDirectory(id: number) {
    return this.http.get('/api/member_directory/' + id).pipe(
      catchError(err => this.handleHttpError(err, memberDirectoryDefault))
    );
  }

  saveDirectory(directory: MemberDirectory) {
    return this.http.post('/api/member_directory', directory).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  updateDirectory(directory: MemberDirectory, id: number) {
    return this.http.patch('/api/member_directory/' + id, directory).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  deleteDirectory(id: number) {
    return this.http.delete('/api/member_directory/' + id).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  testConnection(id: number) {
    return this.http.get('/api/member_directory/' + id + '/test_connection').pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  getOAuthURL(dirID, apiPath, returnSubPath) {
    return `${apiPath}?pk=${dirID}&subpath=${returnSubPath}`;
  }

  getAuthButtons() {
    return this.http.get('api/auth-buttons').pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  private handleHttpError(error: HttpErrorResponse, defaultValue?: any) {
    return this.errorHandlingService.handleHttpError(error, defaultValue);
  }
}
